import React, { useState } from "react";
import Switch from "react-switch";
import MenuProcessService from "../services/MenuProcessService";

function CompanyRights() {
    const [empCode, setEmpCode] = useState("");
    const [plants, setPlants] = useState([]);
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);

    // Load company rights
    const loadCompanys = async () => {
        if (!empCode.trim()) return alert("Enter employee code");
        setLoading(true);
        try {
            const res = await MenuProcessService.getCompanyListData(empCode);
            debugger;
            const list = res.data.result.map(p => ({
                id: p.id, // Already in API
                companyName: p.companyName,
                assign: p.assign === 1 || p.assign === "1" || p.assign === true
            }));
            setPlants(list);
        } catch (err) {
            console.error(err);
            alert("Failed to load plant rights");
        } finally {
            setLoading(false);
        }
    };

    // Toggle assign/unassign
    const togglePlant = (id) => {
        setPlants(prev =>
            prev.map(p => p.id === id ? { ...p, assign: !p.assign } : p)
        );
    };

    // Save rights
    const saveRights = async () => {
        debugger;
        if (!empCode.trim()) return alert("Enter employee code");
        setSaving(true);
        try {
            const assigned = plants.filter(p => p.assign).map(p => parseInt(p.id));
            const unassigned = plants.filter(p => !p.assign).map(p => parseInt(p.id));

            if (assigned.length > 0) {
                await MenuProcessService.setCompanyRights({
                    employeeCode: empCode,
                    CompanyIDs: assigned,
                    assign: true
                });
            }

            if (unassigned.length > 0) {
                await MenuProcessService.setCompanyRights({
                    employeeCode: empCode,
                    CompanyIDs: unassigned,
                    assign: false
                });
            }

            alert("Company rights updated!");
        } catch (err) {
            console.error(err);
            alert("Failed to save Company rights");
        } finally {
            setSaving(false);
        }
    };

    return (
        <div>
            <h4 className="text-left text-primary mb-3">Company Rights</h4>
            <div className="flex gap-2 items-center mb-4">
                <input
                    className="border border-gray-400 p-2 rounded flex-1"
                    placeholder="Enter HR Employeecode"
                    value={empCode}
                    onChange={e => setEmpCode(e.target.value)}
                />
                <button className="btn btn-primary" onClick={loadCompanys} style={{ marginLeft: 10 }}>
                    {loading ? "Loading…" : "Search"}
                </button>
            </div>

            {plants.length > 0 && (
                <>
                    <table className="table">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Company Name</th>
                                <th>Assigned</th>
                            </tr>
                        </thead>
                        <tbody>
                            {plants.map(p => (
                                <tr key={p.id}>
                                    <td>{p.id}</td>
                                    <td>{p.companyName}</td>
                                    <td>
                                        <Switch
                                            checked={p.assign}
                                            onChange={() => togglePlant(p.id)}
                                            onColor="#22c55e"
                                            offColor="#ccc"
                                            height={20}
                                            width={48}
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <button
                        className="btn btn-success mt-3"
                        onClick={saveRights}
                        disabled={saving}
                    >
                        {saving ? "Saving…" : "Save Rights"}
                    </button>
                </>
            )}
        </div>
    );
}

export default CompanyRights;
